import {AxiosError} from 'axios';
import {POST_SEARCH_USER_GROUP_URL} from 'web-library/constants/apiUrls';
import {
  UserGroupDetail
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface UserGroupListingRequest {
  q: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: UserGroupDetail[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostSearchUserGroup = ({onSuccess, onError}: Input = {}) => {
  const postSearchUserGroup = async (requestData: UserGroupListingRequest) => {
    const res = await axiosClient.post<UserGroupDetail[]>(POST_SEARCH_USER_GROUP_URL, {
      q: requestData.q,
    });
    return res.data;
  };

  return useCustomMutation(postSearchUserGroup, {
    onSuccess,
    onError,
  });
};
